module.exports = __webpack_public_path__ + "site/img/whatsapp_en.ca906c86.jpg";